module.exports = __webpack_public_path__ + "static/media/IDEA-Connector.65eb1381.jpg";